<meta name="viewport" content="width=device-width, initial-scale=1.0" />

<body class="bg-gray-50 font-sans">
  <app-header></app-header>

  <!-- About Section -->
  <section class="px-4 sm:px-6 py-12 md:py-16 bg-white">
    <div
      class="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 md:gap-10 items-center"
    >
      <!-- Text -->
      <div class="order-2 md:order-1 animate-fade-in-left delay-100">
        <h2
          class="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 md:mb-6"
        >
          Who <span class="text-teal-600">We Are</span>
        </h2>
        <p class="text-gray-700 leading-relaxed mb-4">
          TrailFusion is an all-in-one software solution that streamlines
          program management for nonprofits and direct-service organizations.
        </p>
        <p class="text-gray-700 leading-relaxed mb-4">
          For administrators, it simplifies scheduling, enrollment, attendance
          tracking, and reporting saving valuable time so staff can focus on
          mentoring.
        </p>
        <p class="text-gray-700 leading-relaxed">
          For parents, TrailFusion provides a secure and convenient way to
          register their children, stay updated on schedules, receive
          communication from staff, and track their child's progress
          <span class="text-teal-600 font-bold">all in one place.</span>
        </p>
      </div>

      <!-- Image -->
      <div class="order-1 md:order-2 animate-fade-in-right delay-200">
        <img
          src="assets/TrailFusion/Miscellaneous/about3.jpeg"
          alt="TrailFusion Programs"
          class="rounded-2xl shadow-lg w-full h-auto object-cover max-h-80 md:max-h-full"
        />
      </div>
    </div>
  </section>

  <!-- Why Us Section -->
  <section class="bg-gray-50 py-12 md:py-16">
    <div
      class="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 md:gap-12 px-4 sm:px-6 items-center"
    >
      <!-- Image -->
      <div class="animate-fade-in-left delay-100">
        <img
          src="assets/TrailFusion/Miscellaneous/about2.png"
          alt="Why TrailFusion"
          class="rounded-2xl shadow-lg w-full h-auto object-cover max-h-80 md:max-h-full"
        />
      </div>

      <!-- Text -->
      <div class="animate-fade-in-right delay-200">
        <h2
          class="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 md:mb-6"
        >
          Why <span class="text-teal-600">TrailFusion?</span>
        </h2>
        <p class="text-gray-700 leading-relaxed mb-4">
          We're always with you. TrailFusion is a 24×7 one-stop solution for
          organizations that currently manage programs manually and want to
          reduce workload, save time, and minimize workforce dependency.
        </p>
        <p class="text-gray-700 leading-relaxed">
          With TrailFusion, you can simplify complex tasks, improve visibility,
          and focus on what matters most making an impact. Whether you're
          running after-school programs, outdoor education, or youth services,
          TrailFusion supports your mission every step of the way.
        </p>
      </div>
    </div>
  </section>

  <!-- Mission -->
  <section class="px-4 sm:px-6 py-12 md:py-16 bg-white">
    <div
      class="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 md:gap-10 items-center"
    >
      <!-- Text -->
      <div class="order-2 md:order-1 animate-fade-in-left delay-100">
        <h2
          class="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 md:mb-6"
        >
          Mission <span class="text-teal-600">Statement</span>
        </h2>
        <p class="text-gray-700 leading-relaxed mb-4">
          We aim to create safe, nurturing spaces where young people can learn
          and grow. By fostering healthy relationships and self-reliance in a
          supportive environment, we help kids explore new opportunities and
          build confidence while equipping program admins with the tools they
          need to deliver high-quality services efficiently.
        </p>
      </div>

      <!-- Image -->
      <div class="order-1 md:order-2 animate-fade-in-right delay-200">
        <img
          src="assets/TrailFusion/Miscellaneous/about1.png"
          alt="TrailFusion Programs"
          class="rounded-2xl shadow-lg w-full h-auto object-cover max-h-80 md:max-h-full"
        />
      </div>
    </div>
  </section>

  <!-- Key Features -->
  <section class="bg-gray-50 py-12 md:py-16">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 text-center">
      <h2
        class="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-8 md:mb-12 animate-fade-in-up"
      >
        Key <span class="text-teal-600">Features</span>
      </h2>
      <div
        class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8"
      >
        <!-- Card -->
        <div
          class="bg-white rounded-xl shadow-md p-4 md:p-6 hover:shadow-lg transition animate-fade-in-up delay-100"
        >
          <i
            class="fas fa-sliders-h text-teal-600 text-2xl md:text-3xl mb-3 md:mb-4"
          ></i>
          <p class="text-gray-700 font-medium text-sm md:text-base">
            Fully customizable for your program needs.
          </p>
        </div>

        <div
          class="bg-white rounded-xl shadow-md p-4 md:p-6 hover:shadow-lg transition animate-fade-in-up delay-200"
        >
          <i
            class="fas fa-calendar-check text-teal-600 text-2xl md:text-3xl mb-3 md:mb-4"
          ></i>
          <p class="text-gray-700 font-medium text-sm md:text-base">
            Smart scheduling & attendance tracking.
          </p>
        </div>

        <div
          class="bg-white rounded-xl shadow-md p-4 md:p-6 hover:shadow-lg transition animate-fade-in-up delay-300"
        >
          <i
            class="fas fa-chart-line text-teal-600 text-2xl md:text-3xl mb-3 md:mb-4"
          ></i>
          <p class="text-gray-700 font-medium text-sm md:text-base">
            Real-time reporting & analytics.
          </p>
        </div>

        <div
          class="bg-white rounded-xl shadow-md p-4 md:p-6 hover:shadow-lg transition animate-fade-in-up delay-400"
        >
          <i
            class="fas fa-campground text-teal-600 text-2xl md:text-3xl mb-3 md:mb-4"
          ></i>
          <p class="text-gray-700 font-medium text-sm md:text-base">
            Ideal for outdoor & youth development programs.
          </p>
        </div>
      </div>
    </div>
  </section>

  <app-footer></app-footer>
</body>
